var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c(
      "div",
      { staticClass: "breadcrumb-layout" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "/" } },
          [
            _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
              _vm._v("首页")
            ]),
            _vm._v(" "),
            _c("el-breadcrumb-item", [_vm._v("合同下单")])
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "block-container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c("el-input", {
                staticClass: "width-1-5x bottom-line",
                attrs: { disabled: true },
                model: {
                  value: _vm.goodsOrder.title,
                  callback: function($$v) {
                    _vm.$set(_vm.goodsOrder, "title", $$v)
                  },
                  expression: "goodsOrder.title"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.contractId != null &&
        _vm.trackPhaseList != null &&
        _vm.trackPhaseList.length > 0
          ? _c("div", { staticClass: "form-group center" }, [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-1-5x" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.trackPhaseId,
                        callback: function($$v) {
                          _vm.trackPhaseId = $$v
                        },
                        expression: "trackPhaseId"
                      }
                    },
                    _vm._l(_vm.trackPhaseList, function(trackPhase) {
                      return _c("el-option", {
                        key: trackPhase.id,
                        attrs: { label: trackPhase.name, value: trackPhase.id }
                      })
                    })
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(3),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.goodsOrder.manualAllocFlag,
                    callback: function($$v) {
                      _vm.$set(_vm.goodsOrder, "manualAllocFlag", $$v)
                    },
                    expression: "goodsOrder.manualAllocFlag"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: true } }, [
                    _vm._v("手工配货")
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: false } }, [
                    _vm._v("自动配货")
                  ])
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(4),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _c("el-input", {
                attrs: { disabled: _vm.contractId != null },
                on: {
                  change: function($event) {
                    _vm.taxRateChange(_vm.goodsOrder.taxRate)
                  }
                },
                model: {
                  value: _vm.goodsOrder.taxRate,
                  callback: function($$v) {
                    _vm.$set(_vm.goodsOrder, "taxRate", $$v)
                  },
                  expression: "goodsOrder.taxRate"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(5),
      _vm._v(" "),
      _c("div", { staticClass: "simple-row" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "button",
            {
              staticClass: "swb-btn swb-btn-small",
              on: {
                click: function($event) {
                  _vm.showShopDlg()
                }
              }
            },
            [_vm._v("选择机构")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("table", { staticClass: "custom-tbl" }, [
        _vm._m(6),
        _vm._v(" "),
        _c("tbody", { staticClass: "body" }, [
          _vm.retailerCom != null
            ? _c("tr", { staticClass: "row" }, [
                _c("td", { staticClass: "align-left" }, [
                  _vm._v(_vm._s(_vm.retailerCom.name))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "align-left" }, [
                  _vm._v(
                    _vm._s(_vm.retailerCom.regionName || "") +
                      _vm._s(_vm.retailerCom.street || "")
                  )
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.retailerCom.contactEmail))]),
                _vm._v(" "),
                _c("td", { staticClass: "align-left" }, [
                  _c(
                    "span",
                    {
                      staticClass: "swb-btn-link",
                      on: {
                        click: function($event) {
                          _vm.removeRetailerCom()
                        }
                      }
                    },
                    [_vm._v("移除")]
                  )
                ])
              ])
            : _c("tr", { staticClass: "row" }, [
                _c("td", { attrs: { colspan: "4" } }, [_vm._v("暂无机构信息")])
              ])
        ])
      ]),
      _vm._v(" "),
      _vm.retailerCom != null && _vm.retailerCom.shopAddrRegionId != null
        ? _c("div", [
            _vm._m(7),
            _vm._v(" "),
            _c("table", { staticClass: "custom-tbl" }, [
              _vm._m(8),
              _vm._v(" "),
              _vm._m(9),
              _vm._v(" "),
              _c("tbody", { staticClass: "body" }, [
                _vm.retailerCom != null
                  ? _c("tr", { staticClass: "row" }, [
                      _c("td", { staticClass: "align-left" }, [
                        _vm._v(_vm._s(_vm.retailerCom.shopAddrAlias))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "align-left" }, [
                        _vm._v(
                          _vm._s(_vm.retailerCom.shopAddrRegionName || "") +
                            _vm._s(_vm.retailerCom.shopAddrStreet || "")
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "a",
                          {
                            staticClass: "font-blue",
                            on: {
                              click: function($event) {
                                _vm.showShopAddrDlg()
                              }
                            }
                          },
                          [_vm._v("更换")]
                        )
                      ])
                    ])
                  : _c("tr", { staticClass: "row" }, [
                      _c("td", { attrs: { colspan: "3" } }, [
                        _c(
                          "a",
                          {
                            staticClass: "font-blue",
                            on: {
                              click: function($event) {
                                _vm.showShopAddrDlg()
                              }
                            }
                          },
                          [_vm._v("选择地址")]
                        )
                      ])
                    ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._m(10),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(11),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _c("el-input", {
                attrs: { type: "input" },
                model: {
                  value: _vm.contactName,
                  callback: function($$v) {
                    _vm.contactName = $$v
                  },
                  expression: "contactName"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(12),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _c("el-input", {
                attrs: { type: "input" },
                model: {
                  value: _vm.contactTel,
                  callback: function($$v) {
                    _vm.contactTel = $$v
                  },
                  expression: "contactTel"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(13),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout" },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.goodsOrder } },
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.goodsOrder.itemList,
                    border: "",
                    "tooltip-effect": "dark"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      width: "180px",
                      prop: "title",
                      label: "商品名称",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      width: "140px",
                      prop: "catName",
                      label: "分类",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      width: "140px",
                      prop: "brandName",
                      label: "品牌",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      width: "140px",
                      prop: "model",
                      label: "型号",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      width: "140px",
                      prop: "fixedSpec",
                      label: "规格",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      width: "140px",
                      prop: "asmblAccFlag",
                      label: "组装件"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(scope.row.asmblAccFlag ? "是" : "否")
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { width: "220", label: "关联定义" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.assetDefId != null &&
                            rows.row.assetDefId != -1
                              ? _c("div", { staticClass: "inline-block" }, [
                                  _vm._v(_vm._s(rows.row.assetDefNo))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn-link fr inline-block",
                                on: {
                                  click: function($event) {
                                    _vm.delDevcDef(rows.row)
                                  }
                                }
                              },
                              [_vm._v("清除")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn-link fr inline-block",
                                on: {
                                  click: function($event) {
                                    _vm.setDevcDef(rows.row)
                                  }
                                }
                              },
                              [_vm._v("选择")]
                            ),
                            _vm._v(" "),
                            (rows.row.assetDefId == null ||
                              rows.row.assetDefId == -1) &&
                            (rows.row.asmblAccFlag ||
                              (!_vm.needAudit && !rows.row.asmblAccFlag))
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "swb-btn-link fr inline-block",
                                    on: {
                                      click: function($event) {
                                        _vm.saveDevcDef(rows.row)
                                      }
                                    }
                                  },
                                  [_vm._v("生成定义")]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      width: "140px",
                      prop: "devcName",
                      label: "定义全名称",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "140px",
                      label: "含税价(元)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm.checkActionPerm("view_item_price")
                              ? _c("div", [
                                  scope.row.customizable
                                    ? _c(
                                        "span",
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "itemList." +
                                                  scope.$index +
                                                  ".price"
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: { type: "text" },
                                                on: {
                                                  change: function($event) {
                                                    _vm.priceChange(scope.row)
                                                  }
                                                },
                                                model: {
                                                  value: scope.row.price,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "price",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.price"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _c("span", [
                                        scope.row.price != null
                                          ? _c("span", [
                                              _vm._v(_vm._s(scope.row.price))
                                            ])
                                          : _c("span", [_vm._v("0.00")])
                                      ])
                                ])
                              : _c("div", [_c("span", [_vm._v("没有权限")])])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { align: "right", width: "140px", label: "税率(%)" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm.checkActionPerm("view_item_price")
                              ? _c("div", [
                                  scope.row.taxRate != null
                                    ? _c("span", [
                                        _vm._v(_vm._s(scope.row.taxRate))
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ])
                              : _c("div", [_c("span", [_vm._v("没有权限")])])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "140px",
                      prop: "ntxPrice",
                      label: "未税价(元)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm.checkActionPerm("view_item_price")
                              ? _c("div", [
                                  scope.row.ntxPrice != null
                                    ? _c("span", [
                                        _vm._v(_vm._s(scope.row.ntxPrice))
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ])
                              : _c("div", [_c("span", [_vm._v("没有权限")])])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "140px",
                      prop: "wrntPeriod",
                      label: "质保期(月)"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      width: "100",
                      label: "是否可定制"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.customized ? "是" : "否"))
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _vm.contractId != null &&
                  _vm.contract != null &&
                  _vm.contract.kindId != null &&
                  _vm.contract.kindId == 0
                    ? _c("el-table-column", {
                        attrs: {
                          align: "right",
                          prop: "goodsQuantity",
                          width: "140px",
                          label: "合同商品数量"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.goodsQuantity))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contractId != null &&
                  _vm.contract != null &&
                  _vm.contract.kindId != null &&
                  _vm.contract.kindId == 0
                    ? _c("el-table-column", {
                        attrs: {
                          align: "right",
                          prop: "surplusQuantity",
                          width: "140px",
                          label: "商品剩余数量"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.goodsQuantity -
                                        scope.row.surplusQuantity
                                    )
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "130px",
                      label: "下单数量"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.customizable
                              ? _c("span", [_vm._v(_vm._s(scope.row.quantity))])
                              : _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "itemList." +
                                        scope.$index +
                                        ".quantity",
                                      rules: {
                                        validator: _vm.validateBaseQuantity,
                                        trigger: "blur"
                                      }
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled:
                                          (scope.row.goodsQuantity -
                                            scope.row.surplusQuantity <=
                                            0 &&
                                            _vm.contractId != null &&
                                            _vm.contract.kindId != null &&
                                            _vm.contract.kindId == 0) ||
                                          scope.row.customized,
                                        type: "text"
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.quantityChange(scope)
                                        }
                                      },
                                      model: {
                                        value: scope.row.quantity,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "quantity", $$v)
                                        },
                                        expression: "scope.row.quantity"
                                      }
                                    })
                                  ],
                                  1
                                )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "unit",
                      width: "80px",
                      label: "单位"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "right",
                      width: "160px",
                      prop: "amount",
                      label: "下单小计(元)"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.amount != null
                              ? _c("div", [
                                  _c("span", [_vm._v(_vm._s(scope.row.amount))])
                                ])
                              : _c("div", [_c("span", [_vm._v("0.00")])])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      width: "180px",
                      label: "说明",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              attrs: { type: "text" },
                              model: {
                                value: scope.row.desc,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "desc", $$v)
                                },
                                expression: "scope.row.desc"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      width: "120px",
                      label: "操作",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.removeGoods(scope.$index)
                                  }
                                }
                              },
                              [_vm._v("移除")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(14),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(15),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _c("el-date-picker", {
                attrs: {
                  disabled: _vm.goodsOrder.desireArriveDays != null,
                  type: "date",
                  placeholder: "选择日期",
                  "picker-options": _vm.pickerOptions0
                },
                model: {
                  value: _vm.goodsOrder.desireArriveDate,
                  callback: function($$v) {
                    _vm.$set(_vm.goodsOrder, "desireArriveDate", $$v)
                  },
                  expression: "goodsOrder.desireArriveDate"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.goodsOrder.desireArriveDays != null
          ? _c("div", { staticClass: "form-group center" }, [
              _vm._m(16),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.goodsOrder.desireArriveDays) + "   天 ")
                ])
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [
          _vm._v("选择" + _vm._s(_vm.contractType == 3 ? "服务商" : "供应商"))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label " }, [
            _c("label", { staticClass: "required" }, [
              _vm._v(
                _vm._s(_vm.contractType == 3 ? "服务商" : "供应商") + "名称"
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c("el-input", {
                staticClass: "width-1-5x bottom-line",
                attrs: { disabled: true },
                model: {
                  value: _vm.goodsOrder.sellerName,
                  callback: function($$v) {
                    _vm.$set(_vm.goodsOrder, "sellerName", $$v)
                  },
                  expression: "goodsOrder.sellerName"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group top" }, [
          _vm._m(17),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c("el-input", {
                staticClass: "width-1-5x bottom-line",
                attrs: {
                  type: "textarea",
                  rows: 3,
                  placeholder: "附言最大长度120个字",
                  maxlength: 120
                },
                model: {
                  value: _vm.goodsOrder.postscript,
                  callback: function($$v) {
                    _vm.$set(_vm.goodsOrder, "postscript", $$v)
                  },
                  expression: "goodsOrder.postscript"
                }
              })
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-toolbar" }, [
      _c(
        "button",
        {
          staticClass: "swb-btn swb-btn-small swb-btn-primary",
          on: { click: _vm.prevContract }
        },
        [_vm._v("返回")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "swb-btn swb-btn-small",
          on: { click: _vm.saveGoodsOrder }
        },
        [_vm._v("保存")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("选择合同")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label " }, [
      _c("label", { staticClass: "required" }, [_vm._v("选择合同")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label " }, [
      _c("label", { staticClass: "required" }, [_vm._v("选择合同阶段")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label " }, [
      _c("label", { staticClass: "required" }, [_vm._v("配货方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label " }, [
      _c("label", { staticClass: "required" }, [_vm._v("税率(%)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("配货机构信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", { staticClass: "align-left" }, [_vm._v("机构名称")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-left" }, [_vm._v("地址")]),
        _vm._v(" "),
        _c("th", [_vm._v("邮箱")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-left" }, [_vm._v("操作")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("收货地址")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col"),
      _vm._v(" "),
      _c("col"),
      _vm._v(" "),
      _c("col", { attrs: { width: "150px" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", { staticClass: "align-left" }, [_vm._v("地址别名")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-left" }, [_vm._v("详细地址")]),
        _vm._v(" "),
        _c("th", [_vm._v("操作")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("联系人信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label " }, [
      _c("label", { staticClass: "required" }, [_vm._v("联系人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label " }, [
      _c("label", { staticClass: "required" }, [_vm._v("联系电话")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("添加商品")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("到货日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label " }, [
      _c("label", { staticClass: "required" }, [_vm._v("要求到货日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("要求到货天数")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("附言")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b0121f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b0121f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/SaveGoodsOrder.vue
// module id = 3254
// module chunks = 0